import React, { useEffect, useState } from 'react';
import cogoToast from 'cogo-toast';
import { font_h3 } from '../Constant/constant';
import sendNodeMail from '../Constant/Email/sendEmailJS';
import { FlexCol, FlexContainer, FlexRow, FormInput, FormLabel, HLButton } from '../Styles';

const ContactPage = () => {

    const input1 = React.createRef()
    const input2 = React.createRef()
    const input3 = React.createRef()
    const input4 = React.createRef()

    const [form, setform] = useState({
        name: '',
        phone: '',
        email: '',
        message: ''
    });
    const handleChange = (e) => {
        e.preventDefault();
        var temp1 = {
            ...form,
            [e.target.name]: e.target.value
        }
        setform(temp1)
        // console.log(form)
    }

    const [columnWidth, setcolumnWidth] = useState('35%');

    const resizeWindow = () => {
        // if (window.innerWidth != screenSize) {
        // setscreenSize(window.innerWidth);
        let sz = window.innerWidth > 1200 ? "35%" : window.innerWidth > 1000 ? "50%" : "60%";
        setcolumnWidth(sz)
        // }
    }
    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("resize", resizeWindow);
    }, [])

    const submitMail = (e) => {
        if (form.name && form.email && form.phone && form.message) {
            console.log(form.name, form.email, 'A New Message from the ' + form.name, form.message)
            sendNodeMail(form.name, form.email, form.phone, form.message, cogoToast)
        } else {
            if (!form.name) {
                let wrapper = input1.current;
                wrapper.classList.toggle('shakeAnime');
                setTimeout(() => {
                    wrapper.classList.toggle('shakeAnime');
                }, 900);
            }
            if (!form.email) {
                let wrapper = input2.current;
                wrapper.classList.toggle('shakeAnime');
                setTimeout(() => {
                    wrapper.classList.toggle('shakeAnime');
                }, 900);
            }
            if (!form.phone) {
                let wrapper = input3.current;
                wrapper.classList.toggle('shakeAnime');
                setTimeout(() => {
                    wrapper.classList.toggle('shakeAnime');
                }, 900);
            }
            if (!form.message) {
                let wrapper = input4.current;
                wrapper.classList.toggle('shakeAnime');
                setTimeout(() => {
                    wrapper.classList.toggle('shakeAnime');
                }, 900);
            }
        }
    }

    return (
        <FlexContainer>
            <FlexRow style={{ minHeight: 10, marginTop: 32, marginBottom: 40 }}>
                <FlexCol basis="auto" style={{ fontSize: font_h3 }}>
                    GET IN TOUCH
                </FlexCol>
            </FlexRow>
            <FlexRow justify="center" align="flex-start" className="form-control">
                <FlexCol basis={columnWidth} className="formInputs">
                    <FormLabel className="contact-labels">Name</FormLabel>
                    <FormInput ref={input1} name="name" type="text" className="contactInputs" value={form.name} onChange={(e) => handleChange(e)} placeholder="Enter Name" />
                </FlexCol>
                <FlexCol basis={columnWidth} className="formInputs">
                    <FormLabel className="contact-labels">Mobile Number</FormLabel>
                    <FormInput ref={input2} name="phone" type="text" className="contactInputs" value={form.phone} onChange={(e) => handleChange(e)} placeholder="Enter Phone" />
                </FlexCol>
                <FlexCol basis={columnWidth} className="formInputs">
                    <FormLabel className="contact-labels">Email</FormLabel>
                    <FormInput ref={input3} name="email" type="text" className="contactInputs" value={form.email} onChange={(e) => handleChange(e)} placeholder="Enter Email" />
                </FlexCol>
                <FlexCol basis={columnWidth} className="formInputs">
                    <FormLabel className="contact-labels">Message</FormLabel>
                    <FormInput ref={input4} name="message" type="text" className="contactInputs" value={form.message} onChange={(e) => handleChange(e)} placeholder="Enter Message" />
                </FlexCol>
                <FlexCol basis={columnWidth} className="formInputs">
                    <br />
                    <br />
                    <HLButton onClick={(e) => { submitMail(e) }} >
                        SUBMIT
                    </HLButton>
                </FlexCol>
            </FlexRow>
        </FlexContainer >
    );
}

export default ContactPage;